(() => {
  const ELEMENT_NAME = "header-block";
  const attributes = {
    toggler: `data-${ELEMENT_NAME}-toggler`,
    toggleOverflow: `data-${ELEMENT_NAME}-toggle-overflow`,
    target: `data-${ELEMENT_NAME}-target`,
    toggleClass: `data-${ELEMENT_NAME}-toggler-class`,
    togglerMobile: `data-${ELEMENT_NAME}-toggler-mobile`,
    focusTarget: `data-${ELEMENT_NAME}-focus-target`,
    secondaryMenu: `data-${ELEMENT_NAME}-secondary-menu`,
    secondaryMenuToggler: `data-${ELEMENT_NAME}-secondary-menu-toggler`,
    secondaryMenuTogglerClass: `data-${ELEMENT_NAME}-secondary-menu-toggler-class`,
    secondaryMenuClose: `data-${ELEMENT_NAME}-secondary-menu-close`,
    parentHovered: `data-${ELEMENT_NAME}-parent-hovered`,
  };
  class HeaderBlock extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initScrollEvent();
      this.syncHeaderColors();

      this.$secondaryMenus = Array.from(this.querySelectorAll(`[${attributes.secondaryMenu}]`));

      this.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(evt) {
      this.handleToggler(evt);
      this.handleSecondaryMenuToggler(evt);
      this.handleSecondaryMenuClose(evt)
    }

    handleSecondaryMenuClose(evt) {
      const $close = evt.target.closest(`[${attributes.secondaryMenuClose}]`);

      if(!$close) return;

      const $menu = $close.closest(`[${attributes.secondaryMenu}]`);
      const closeClass = $close.getAttribute(attributes.secondaryMenuTogglerClass)

      $menu.classList.remove(closeClass)
    }

    handleSecondaryMenuToggler(evt) {
      const $toggler = evt.target.closest(
        `[${attributes.secondaryMenuToggler}]`
      );

      if (!$toggler) return;
      if (
        $toggler.hasAttribute(attributes.togglerMobile) &&
        window.matchMedia("(min-width: 768px)").matches
      )
        return;

      const targetId = $toggler.getAttribute(attributes.secondaryMenuToggler);
      const className = $toggler.getAttribute(
        attributes.secondaryMenuTogglerClass
      );
      const menuClassName = $toggler.getAttribute(attributes.toggleClass);

      if (!targetId) return;

      evt.preventDefault();
      
      for (let i = 0; i < this.$secondaryMenus.length; i++) {
        const $item = this.$secondaryMenus[i];
        $item.classList.toggle(className, $item.id == targetId);
      }
    }

    handleToggler(evt) {
      const $toggler = evt.target.closest(`[${attributes.toggler}]`);

      if (!$toggler) return;
      if (
        $toggler.hasAttribute(attributes.togglerMobile) &&
        window.matchMedia("(min-width: 768px)").matches
      )
        return;

      const $target = document.querySelector(
        $toggler.getAttribute(attributes.target)
      );
      const $focusTarget = $toggler.hasAttribute(attributes.focusTarget)
        ? this.querySelector($toggler.getAttribute(attributes.focusTarget))
        : null;

      const toggleOverflow = $toggler.hasAttribute(attributes.toggleOverflow);

      toggleOverflow && document.body.classList.toggle("overflow-hidden");

      $target &&
        $target.classList.toggle($toggler.getAttribute(attributes.toggleClass));

      $focusTarget && $focusTarget.focus();
      $focusTarget && $focusTarget.scrollIntoView();
    }

    initScrollEvent() {
      window.addEventListener("scroll", this.syncHeaderColors.bind(this));
    }

    syncHeaderColors() {
      document.body.toggleAttribute("data-scrolled", window.scrollY > 60);
    }
  }

  customElements.define(ELEMENT_NAME, HeaderBlock);
})();
